'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = window.jQuery;
var cart_currency_symbol = window.ZBX_CART_VAR.cart_currency_symbol;

var loadingTimer = null;
var DEBOUNCE_DURING = 800;
var debounce_counter = new Date().getTime();
function cartDrawDebounce(nowTime) {
  var result = nowTime - debounce_counter > DEBOUNCE_DURING;
  if (result) {
    debounce_counter = nowTime;
  }
  return result;
}

var CartDraw = function (_React$Component) {
  _inherits(CartDraw, _React$Component);

  function CartDraw(props) {
    _classCallCheck(this, CartDraw);

    var _this = _possibleConstructorReturn(this, (CartDraw.__proto__ || Object.getPrototypeOf(CartDraw)).call(this, props));

    _this.state = {
      items: [],

      currency: '',

      total_discount: 0,
      total_price: 0,
      total_weight: 0,
      cart_level_discount_applications: [],
      requires_shipping: false,
      original_total_price: 0,
      items_subtotal_price: 0,
      item_count: 0,
      last_items_length: 0,
      note: null,
      token: '',

      showLoading: false,

      warnMsg: ''
    };

    _this._bindEvent();

    _this._addCartItem = _this._addCartItem.bind(_this);

    return _this;
  }

  // componentDidMount() {
  //   this._open();
  // }


  _createClass(CartDraw, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (loadingTimer) {
        clearTimeout(loadingTimer);
        loadingTimer = null;
      }
    }
  }, {
    key: '_open',
    value: function _open() {
      $('body').addClass('zb-cart-draw-open');
      this._fetchCartItems();
    }
  }, {
    key: '_close',
    value: function _close() {
      $('body').removeClass('zb-cart-draw-open');
    }
  }, {
    key: '_bindEvent',
    value: function _bindEvent() {
      var _this2 = this;

      var eventClass = window.ZBX_CART_VAR.cart_drawer_event_class;

      var eventClassArray = eventClass.split(',');
      // console.log('eventClassArray', eventClassArray);
      $('.zb-cart-draw-bg').on('click', function () {
        return _this2._close();
      });

      $('.zb-cart-draw-btn-close').on('click', function () {
        return _this2._close();
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = eventClassArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var eventClassItem = _step.value;

          $(document).on('click', '.' + eventClassItem.toString(), function (evt) {
            // evt.stopPropagation();
            evt.preventDefault();
            _this2._open();
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $(document).on('click', '.gf_add-to-cart', function (evt) {
        evt.preventDefault();

        _this2._addCartByForm().finally(function () {
          _this2._open();
        });

        return false;
      });
    }
  }, {
    key: '_addCartByForm',
    value: function _addCartByForm() {
      var addToCartForm = document.querySelector('form[action="/cart/add"]');
      var formData = new FormData(addToCartForm);
      // console.log('formData', formData);
      return fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      }).then(function (response) {
        return response.json();
      });
    }
  }, {
    key: '_fetchCartItems',
    value: function _fetchCartItems() {
      var _this3 = this;

      return fetch('/cart.js', {
        method: 'GET'
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        // console.log('cart======', cart);
        _this3.setState(Object.assign({}, cart, {
          showLoading: false
        }));
        // this._refreshHeaderCartNumber(cart.items.length); // [productA.quantity: 3, productA.quantity: 1] item_count = 2
        _this3._refreshHeaderCartNumber(cart.item_count); // [productA.quantity: 3, productA.quantity: 1] item_count=4
        return cart;
      });
    }
  }, {
    key: '_refreshHeaderCartNumber',
    value: function _refreshHeaderCartNumber(newItemLength) {
      var last_items_length = this.state.last_items_length;

      if (last_items_length !== newItemLength) {
        var cartCount = $('#CartCount span:first');
        var cartCountNum = parseInt(cartCount.text());
        if (cartCountNum !== newItemLength) {
          cartCount.text(newItemLength.toFixed());
        }
        this.setState({
          last_items_length: newItemLength
        });
      }
    }
  }, {
    key: '_findProduct',
    value: function _findProduct(variant_id) {
      var items = this.state.items;

      var result = null;
      if (items && items.length) {
        result = items.find(function (item) {
          return item.id === variant_id || item.variant_id && item.variant_id === variant_id;
        });
        // console.log('find', result);
      }
      return result;
    }
  }, {
    key: '_dealQuantityInputData',
    value: function _dealQuantityInputData(data) {
      var _ref = data || {},
          status = _ref.status,
          message = _ref.message,
          description = _ref.description;

      if (message && description) {
        this.setState({
          warnMsg: description || '',
          showLoading: false
        });
      } else {
        this._fetchCartItems();
      }
    }
  }, {
    key: '_addCartItem',
    value: function _addCartItem(variant_id, quantity) {
      var _this4 = this;

      var nowTime = new Date().getTime();
      if (!cartDrawDebounce(nowTime)) return null;
      this.setState({ showLoading: true });

      var _ref2 = this._findProduct(variant_id) || {},
          cartQuantity = _ref2.quantity;

      if (!cartQuantity) {
        // $.post('/cart/update.js', {update:updateData}).always((recv)=>console.log(recv))
        $.post('/cart/add.js', {
          items: [{
            quantity: quantity,
            id: variant_id
          }]
        }).always(function (recv) {
          // console.log('/cart/add.js', recv);
          try {
            var recvType = typeof recv === 'undefined' ? 'undefined' : _typeof(recv);
            switch (recvType) {
              case "string":
                {
                  var responseData = JSON.parse(recvType);
                  _this4._dealQuantityInputData(responseData);
                  break;
                }
              case "object":
                {
                  var responseText = recv.responseText,
                      status = recv.status;

                  var _responseData = JSON.parse(responseText);
                  _this4._dealQuantityInputData(_responseData);
                  break;
                }
              default:
                {
                  _this4._dealQuantityInputData({ message: '', description: '' });
                }
            }
          } catch (e) {
            console.warn('cart/add.js error', e);
            _this4._dealQuantityInputData({ message: '', description: '' });
          }
        });
      } else {
        var newQuantity = quantity + cartQuantity;
        var formData = new FormData();
        formData.append('id', variant_id);
        formData.append('quantity', newQuantity);
        fetch('/cart/change.js', {
          method: 'POST',
          body: formData
        }).then(function (resp) {
          return resp.json();
        }).then(function (data) {
          return _this4._dealQuantityInputData(data);
        });
      }
    }
  }, {
    key: '_removeCartItem',
    value: function _removeCartItem(variant_id) {
      var _this5 = this;

      this.setState({ showLoading: true });
      var formData = new FormData();
      formData.append('id', variant_id);
      formData.append('quantity', '0');
      fetch('/cart/change.js', {
        method: 'POST',
        body: formData
      }).then(function (resp) {
        return resp.json();
      }).then(function (data) {
        return _this5._dealQuantityInputData(data);
      });
    }
  }, {
    key: '_renderCartItem',
    value: function _renderCartItem(item) {
      var _this6 = this;

      if (!item) {
        return null;
      }
      var image = item.image,
          id = item.id,
          url = item.url,
          product_title = item.product_title,
          title = item.title,
          variant_title = item.variant_title,
          quantity = item.quantity,
          price = item.price;

      var that = this;
      return React.createElement(
        'div',
        { className: 'zb-cart-item', key: id },
        React.createElement(
          'div',
          { className: 'zb-item-wrap' },
          React.createElement(
            'div',
            { className: 'zb-item-image-box' },
            React.createElement(
              'a',
              { href: url, target: '_blank', title: title },
              React.createElement('img', { src: image, alt: title })
            )
          ),
          React.createElement(
            'div',
            { className: 'zb-item-meta' },
            React.createElement(
              'div',
              { className: 'zb-item-close', onClick: function onClick() {
                  _this6._removeCartItem(id);
                } },
              'X'
            ),
            React.createElement(
              'div',
              { className: 'zb-item-product' },
              React.createElement(
                'div',
                { className: 'zb-product-title' },
                product_title
              ),
              React.createElement(
                'div',
                { className: 'zb-variant-title' },
                variant_title
              )
            ),
            React.createElement(
              'div',
              { className: 'zb-item-quantity-price' },
              React.createElement(
                'div',
                { className: 'zb-quantity' },
                React.createElement(
                  'div',
                  { className: 'zb-quantity-content' },
                  React.createElement(QuantityInput, { value: quantity,
                    onSubtract: function onSubtract(val) {
                      _this6.setState({ showLoading: true });
                      var formData = new FormData();
                      formData.append('id', id);
                      formData.append('quantity', val);
                      fetch('/cart/change.js', {
                        method: 'POST',
                        body: formData
                      }).then(function (resp) {
                        return resp.json();
                      }).then(function (data) {
                        return _this6._dealQuantityInputData(data);
                      });
                    },
                    onAdd: function onAdd(val) {
                      _this6.setState({ showLoading: true });
                      var formData = new FormData();
                      formData.append('id', id);
                      formData.append('quantity', val);
                      fetch('/cart/change.js', {
                        method: 'POST',
                        body: formData
                      }).then(function (resp) {
                        return resp.json();
                      }).then(function (data) {
                        return _this6._dealQuantityInputData(data);
                      });
                    }
                  })
                )
              ),
              React.createElement(
                'div',
                { className: 'zb-price' },
                cart_currency_symbol,
                ' ',
                (price / 100).toFixed(2)
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderCartItemList',
    value: function renderCartItemList() {
      var _this7 = this;

      var items = this.state.items;


      return React.createElement(
        'div',
        { className: 'zb-cart-list' },
        items.length ? items.map(function (item) {
          return _this7._renderCartItem(item);
        }) : React.createElement(
          'div',
          { className: 'zb-cart-list-null' },
          'The cart is empty'
        )
      );
    }
  }, {
    key: '_matchRecommend',
    value: function _matchRecommend() {
      var has_recommended_tags = {}; // {tagName: true|false(is that tags has been recommended)}
      var items = this.state.items;

      var ZBX_CART_VAR = window.ZBX_CART_VAR;
      var _ZBX_CART_VAR$recomme = ZBX_CART_VAR.recommend_tags,
          recommend_tags = _ZBX_CART_VAR$recomme === undefined ? [] : _ZBX_CART_VAR$recomme;
      // console.log('items', items);

      var recommendCollections = [];
      for (var i = 0; i < 12; i++) {
        if (recommend_tags[i] !== undefined) {
          recommendCollections.push({
            dataKey: 'key' + i,
            nameKey: recommend_tags[i] || '',
            collection: [].concat(_toConsumableArray(ZBX_CART_VAR['recommend_collections' + (i + 1)]))
          });
        }
      }
      // console.log('recommendCollections', recommendCollections);
      var result = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          var _ref3 = item || {},
              product_title = _ref3.product_title;

          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = recommendCollections[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var recommendCollection = _step4.value;
              var nameKey = recommendCollection.nameKey,
                  collection = recommendCollection.collection,
                  dataKey = recommendCollection.dataKey;
              // console.log(nameKey, collection);

              if (!has_recommended_tags || !has_recommended_tags[dataKey]) {
                var hasKey = product_title.indexOf(nameKey) > -1;
                if (hasKey) {
                  has_recommended_tags[dataKey] = true;

                  var _loop2 = function _loop2(collectionProduct) {
                    if (!result.find(function (product) {
                      return product.id === collectionProduct.id;
                    })) {
                      result.push(collectionProduct);
                    }
                  };

                  var _iteratorNormalCompletion5 = true;
                  var _didIteratorError5 = false;
                  var _iteratorError5 = undefined;

                  try {
                    for (var _iterator5 = collection[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                      var collectionProduct = _step5.value;

                      _loop2(collectionProduct);
                    }
                  } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                      }
                    } finally {
                      if (_didIteratorError5) {
                        throw _iteratorError5;
                      }
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _loop = function _loop(_item) {
        var _ref4 = _item || {},
            product_id = _ref4.product_id;

        var repeatedProductIndex = -1;
        result.forEach(function (resultProduct, idx) {
          if (resultProduct.id === product_id) {
            repeatedProductIndex = idx;
          }
        });
        if (repeatedProductIndex > -1) {
          result.splice(repeatedProductIndex, 1);
        }
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = items[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _item = _step3.value;

          _loop(_item);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return result;
    }
  }, {
    key: 'renderRecommendProducts',
    value: function renderRecommendProducts() {
      var _this8 = this;

      var items = this.state.items;
      // console.log('recommend_products==  ', recommend_products);

      if (!items || !items.length) return null;
      var recommend_products = this._matchRecommend() || [];
      // console.log('recommend_products', recommend_products);
      if (!recommend_products.length) {
        return null;
      }

      return React.createElement(
        'div',
        { className: 'zb-recommend-products' },
        React.createElement(
          'h2',
          { className: 'h2' },
          'You may also like'
        ),
        React.createElement(
          'div',
          { className: 'zb-products-list' },
          recommend_products.filter(function (item) {
            return !!item.available;
          }).map(function (product) {
            return React.createElement(Product, { key: product.id,
              product: product,
              onAdd: _this8._addCartItem });
          })
        )
      );
    }
  }, {
    key: 'renderCheckout',
    value: function renderCheckout() {
      var _this9 = this;

      var _state = this.state,
          items_subtotal_price = _state.items_subtotal_price,
          currency = _state.currency;

      return React.createElement(
        'div',
        { className: 'zb-checkout-box' },
        React.createElement(
          'div',
          { className: 'zb-checkout-box-inner' },
          React.createElement(
            'div',
            { className: 'zb-total-row' },
            React.createElement(
              'span',
              null,
              'Subtotal'
            ),
            React.createElement(
              'span',
              null,
              cart_currency_symbol,
              ' ',
              (items_subtotal_price / 100).toFixed(2),
              ' ',
              currency
            )
          ),
          React.createElement(
            'div',
            { className: 'zb-checkout-btn-row' },
            React.createElement(
              'a',
              { className: 'button', href: '/checkout' },
              'Checkout'
            ),
            React.createElement(
              'div',
              { className: 'continue-btn', onClick: function onClick() {
                  return _this9._close();
                } },
              'Continue Shopping'
            )
          )
        )
      );
    }
  }, {
    key: '_renderWarnMsg',
    value: function _renderWarnMsg() {
      var _this10 = this;

      var warnMsg = this.state.warnMsg;

      var msgDivProps = {
        className: warnMsg ? 'zb-cart-warn show-msg' : 'zb-cart-warn hide-msg'
      };
      return React.createElement(
        'div',
        Object.assign({}, msgDivProps, { onClick: function onClick() {
            return _this10.setState({ warnMsg: '' });
          } }),
        warnMsg
      );
    }
  }, {
    key: '_renderLoading',
    value: function _renderLoading() {
      var showLoading = this.state.showLoading;

      var that = this;
      if (showLoading && loadingTimer === null) {
        loadingTimer = setTimeout(function () {
          var nowShowLoading = that.state.showLoading;

          clearTimeout(loadingTimer);
          loadingTimer = null;
          if (nowShowLoading) {
            that.setState({
              warnMsg: 'Connection timed out, please try again later',
              showLoading: false
            });
          }
        }, 10000);
      } else if (!showLoading && loadingTimer) {
        clearTimeout(loadingTimer);
        loadingTimer = null;
      }
      return showLoading ? React.createElement(
        'div',
        { className: 'zb-cart-loading' },
        React.createElement(
          'div',
          { className: 'zb-cart-loading-text' },
          'loading...'
        )
      ) : null;
    }
  }, {
    key: '_renderFooterMessage',
    value: function _renderFooterMessage() {
      // console.log('window.ZBX_CART_VAR==', window.ZBX_CART_VAR);
      var _window$ZBX_CART_VAR = window.ZBX_CART_VAR,
          cart_drawer_message = _window$ZBX_CART_VAR.cart_drawer_message,
          cart_drawer_message_color = _window$ZBX_CART_VAR.cart_drawer_message_color;

      var innerText = cart_drawer_message.replace(/\n/g, "<br/>");
      // console.log('cart_drawer_message', cart_drawer_message, innerText);
      var messageStyle = {
        color: cart_drawer_message_color
      };
      return cart_drawer_message ? React.createElement('div', { className: 'zb-cart-draw-message', style: messageStyle, dangerouslySetInnerHTML: { __html: "" } }) : null;
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        this._renderWarnMsg(),
        this.renderCartItemList(),
        this.renderRecommendProducts(),
        this.renderCheckout(),
        this._renderFooterMessage(),
        this._renderLoading()
      );
    }
  }]);

  return CartDraw;
}(React.Component);

var Product = function (_React$Component2) {
  _inherits(Product, _React$Component2);

  function Product(props) {
    _classCallCheck(this, Product);

    var _this11 = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props));

    _this11.state = {
      quantityValue: 1,
      selectedVariantId: props.product.variants[0].id
    };
    return _this11;
  }

  _createClass(Product, [{
    key: 'render',
    value: function render() {
      var _this12 = this;

      var _props$product = this.props.product,
          featured_image = _props$product.featured_image,
          id = _props$product.id,
          handle = _props$product.handle,
          title = _props$product.title,
          variants = _props$product.variants,
          price = _props$product.price;
      var _state2 = this.state,
          quantityValue = _state2.quantityValue,
          selectedVariantId = _state2.selectedVariantId;


      return React.createElement(
        'div',
        { className: 'zb-product', key: id },
        React.createElement(
          'div',
          { className: 'zb-product-image' },
          React.createElement(
            'a',
            { href: '/products/' + handle, target: '_blank', title: title },
            React.createElement('img', { className: 'zb-item-image', alt: title, src: featured_image })
          )
        ),
        React.createElement(
          'div',
          { className: 'zb-product-meta' },
          React.createElement(
            'div',
            { className: 'zb-product-title' },
            title
          ),
          React.createElement(
            'div',
            { className: 'zb-product-price' },
            React.createElement(
              'div',
              { className: 'zb-price' },
              cart_currency_symbol,
              (price / 100).toFixed(2)
            )
          ),
          React.createElement(
            'div',
            { className: 'zb-product-variants-add' },
            React.createElement(
              'div',
              { className: 'zb-product-variants' },
              React.createElement(
                'select',
                { value: selectedVariantId, onChange: function onChange(evt) {
                    _this12.setState({
                      selectedVariantId: evt.target.value
                    });
                  } },
                variants.map(function (variant) {
                  return React.createElement(
                    'option',
                    { value: variant.id },
                    variant.title
                  );
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'zb-product-add' },
              React.createElement(
                'div',
                { className: 'button', onClick: function onClick() {
                    _this12.props.onAdd(_this12.state.selectedVariantId, _this12.state.quantityValue);
                  } },
                'Add'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'zb-quantity' },
            React.createElement(
              'div',
              { className: 'zb-quantity-content' },
              React.createElement(QuantityInput, {
                value: quantityValue,
                itemID: id,
                onSubtract: function onSubtract(val) {
                  _this12.setState({
                    quantityValue: val
                  });
                },
                onAdd: function onAdd(val) {
                  _this12.setState({
                    quantityValue: val
                  });
                } })
            )
          )
        )
      );
    }
  }]);

  return Product;
}(React.Component);

var QuantityInput = function (_React$Component3) {
  _inherits(QuantityInput, _React$Component3);

  function QuantityInput(props) {
    _classCallCheck(this, QuantityInput);

    return _possibleConstructorReturn(this, (QuantityInput.__proto__ || Object.getPrototypeOf(QuantityInput)).call(this, props));
  }

  _createClass(QuantityInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$onAdd = _props.onAdd,
          onAdd = _props$onAdd === undefined ? function () {} : _props$onAdd,
          _props$onSubtract = _props.onSubtract,
          onSubtract = _props$onSubtract === undefined ? function () {} : _props$onSubtract,
          value = _props.value;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'zb-btn-minus', onClick: function onClick() {
              var nowTime = new Date().getTime();
              if (!cartDrawDebounce(nowTime)) return null;
              if (value > 0) {
                onSubtract(value - 1);
              }
            } },
          '-'
        ),
        React.createElement('input', { className: 'zb-quantity-input', type: 'text', value: value }),
        React.createElement(
          'div',
          { className: 'zb-btn-plus', onClick: function onClick() {
              var nowTime = new Date().getTime();
              if (!cartDrawDebounce(nowTime)) return null;
              onAdd(value + 1);
            } },
          '+'
        )
      );
    }
  }]);

  return QuantityInput;
}(React.Component);

var cartDrawContainer = document.querySelector('#cart_draw_container');
ReactDOM.render(React.createElement(CartDraw, null), cartDrawContainer);

(function () {
  $('.gf_add-to-cart').parent().attr('data-ajaxcart', 0);
})();

/** 购物车插件使用指南
 * 此购物车为右侧弹窗形式，加购后会展示推荐商品，可以对购物车内商品进行增减操作，点击checkout后会跳转到结算页
 *
 * 数据配置：
 *  后台->模版设置->cart draw,
 *  可以配置推荐产品系列
 *  指定class绑定点击事件，用于呼出购物车
 * 插件使用：
 *  assets 下导入[react.production.min.js, react-compiled.js, react-dom.production.min.js, zb-cart-draw.css]
 *    必要时可以导入jquery.min.js
 *  snippets 下导入cart-draw.liquid
 *  sections/header.liquid 中最外部加入 `{%- render 'cart-draw' -%}`
 **/
